import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { useParams } from "@/lib/navigation";
import { TaxDiscrepancies } from "@/components/Taxes/Discrepancies";

function TaxDiscrepanciesContent() {
  const { tax_year } = useParams<{ tax_year: string }>();
  return <TaxDiscrepancies taxYear={tax_year} />;
}

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <TaxDiscrepanciesContent />
    </Suspense>
  );
}

export const Route = createFileRoute("/_authenticated/taxes/discrepancies/$tax_year/")({
  component: RouteComponent,
  staticData: { page: "tax" },
});
